export default function addTrackingToBackLink(event) {
  if (!window.dataLayer) {
    return false;
  }
  return window.dataLayer.push({
    event: 'ga.event',
    ga_event_category: 'nav',
    ga_event_action: 'map_view_srp_back_to_list_view',
    ga_event_label: `from: ${window.location.href} | to: ${event.target.href}`,
  });
}
